{
  "RESET_PASSWORD": {
    "TITLE": "Reimposta password",
    "DESCRIPTION": "Inserisci l'indirizzo email che usi per accedere a Chatwoot per ottenere le istruzioni per reimpostare la password.",
    "GO_BACK_TO_LOGIN": "Se vuoi tornare alla pagina di login,",
    "EMAIL": {
      "LABEL": "Email",
      "PLACEHOLDER": "Inserisci il tuo indirizzo email.",
      "ERROR": "Inserisci un indirizzo email valido."
    },
    "API": {
      "SUCCESS_MESSAGE": "Il link per reimpostare la password è stato inviato alla tua email.",
      "ERROR_MESSAGE": "Impossibile connettersi al server Woot. Riprova."
    },
    "SUBMIT": "Invia"
  }
}
